// extracted by mini-css-extract-plugin
export default {"mainWrapper":"LoadingUploadDisciplineList_mainWrapper__UZB4k","rowWrapper":"LoadingUploadDisciplineList_rowWrapper__noCrt","rowLeft":"LoadingUploadDisciplineList_rowLeft__Z-8PY"};